import { instance } from '@/api'

export const W_MATERIAL_URL = 'warehouse/w-materials'

export default {
  /*
  * Получение материалов для резерва по d_wire и article
  * */
  getMaterialsForReserve: async (params) => {
    return await instance.get(W_MATERIAL_URL, { params })
  },

  /*
  * Получение текущих резервов для материала
  * */
  getReserve: async (id) => {
    return await instance.get(W_MATERIAL_URL + `/${id}/reserved`)
  },

  /*
  * Резервирование материала
  * */
  setReserve: async (id, data) => {
    return await instance.post(W_MATERIAL_URL + `/${id}`, data)
  }
}
